module.exports = __webpack_public_path__ + "img/zfcg_03.2094d1c0.png";